import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { PROGRESS_ROUTES as PROGRESS_ROUTE_CONSTANTS } from '../../route-constants';

const ProgressRoot = lazy(() => import('@~/pages/progress-timeline/progress-root'));
const ProgressTimeline = lazy(() => import('@~/pages/progress-timeline/daily-timeline'));
const MonthlyTab = lazy(() => import('@~/pages/progress-timeline/monthly-timeline'));

export const PROGRESS_ROUTES: RouteObject = {
  path: PROGRESS_ROUTE_CONSTANTS.ROOT.PATH,
  element: <ProgressRoot />,
  handle: {
    pageName: PROGRESS_ROUTE_CONSTANTS.ROOT.NAME,
  },
  children: [
    {
      path: PROGRESS_ROUTE_CONSTANTS.DAILY.RELATIVE_PATH,
      element: <ProgressTimeline />,
      handle: {
        pageName: PROGRESS_ROUTE_CONSTANTS.DAILY.NAME,
      },
    },
    {
      path: PROGRESS_ROUTE_CONSTANTS.MONTHLY.RELATIVE_PATH,
      element: <MonthlyTab />,
      handle: {
        pageName: PROGRESS_ROUTE_CONSTANTS.MONTHLY.NAME,
      },
    },
  ],
};
